module.exports = __webpack_public_path__ + "static/media/insect(25).5b28c993.PNG";